export const Logo = ({ className = "text-2xl", testid = "logo" }) => (
  <span
    data-testid={testid}
    className={`font-heading font-black tracking-tighter text-white inline-flex items-center select-none ${className}`}
  >
    VDY
    <span
      className="inline-flex items-center justify-center rounded-full border-[0.14em] border-white"
      style={{ width: "0.92em", height: "0.92em", marginLeft: "0.06em" }}
    >
      <svg
        viewBox="0 0 10 12"
        style={{ width: "0.34em", height: "0.4em", marginLeft: "0.05em" }}
        aria-hidden="true"
      >
        <path d="M0 0 L10 6 L0 12 Z" fill="#C8F031" />
      </svg>
    </span>
  </span>
);

export default Logo;
